import styled from 'styled-components';
import { getSectionGradient, media, space } from '../../ui/helpers';
import { colors } from '../../ui/design-tokens';
import fonts from '../../ui/fonts';

const Module = styled.div<{ gradient: boolean, centeredContent?: boolean }>`
  background: ${({ theme, gradient }) => (gradient ? getSectionGradient(theme) : theme.background)};
  color: ${({ theme }) => theme.color};
  padding: 0;

  ${media.max('medium')`
     background-repeat: no-repeat;
  `}

  ${media.min('medium')`

    padding: 0;

     ${({centeredContent}) => {
      if (centeredContent) {
        return `
          padding: 0 0;
        `;
      }
    }}
  `}

  ${media.max('small')`
    padding: 0;
  `}
`;

const ContentZone = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0;

  &.reverse {
    flex-direction: column;
  }

  .imgFullBackground & {
    margin: 0;
    padding: 0;
    flex-direction: column;

    ${media.min('medium')`
      max-width: 50%;
      display: flex;
      align-items: center;
      background: rgba(0, 0, 0, 0.5);
      max-width: 50%;
      margin: 0;

      &.reverse {
        flex-direction: row-reverse;
      }

      .imgMobile {
        display: none;
      }
    `};

    ${media.min('fullwidth')`
      background: rgba(0, 0, 0, 0.5);
      max-width: 50%;
      margin: 0;
    `};

    .text {
      margin-left: 0;
    }
  }

  ${media.min('medium')`
    padding: 0;
    flex-direction: row;

    &.reverse {
      flex-direction: row-reverse;
    }
  `};

  ${media.max('fullwidth')`
    max-width: 100%;
  `};

  ${media.min('fullwidth')`
    margin: 0 auto;
    padding: 0;
  `};
`;
const Container = styled.div`
  display: flex;
  flex-direction: column-reverse;
  text-align: center;
  padding: 0;
  max-width: 100%;
  height: 100%;

  ${media.min('medium')`
    flex-direction: row;
    text-align: left;
    display: flex;
    align-items: stretch; // Importante: stretch para que la imagen ocupe todo el alto
    height: 100%;
  `}

  ${media.max('fullwidth')`
      max-width: 100%;
  `};
`;

const TextZone = styled.div<{ isShop: boolean; gradient: boolean }>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  padding: 64px ${space(3)} 64px ${space(3)}; // padding del texto: más altura arriba y abajo

  .title {
    color: ${({ theme }) => theme.color};
    ${fonts.titleLG};
    margin-bottom: ${space(2)};
  }

  .subtitle {
    ${fonts.highlightsMD};
    padding: 0;
  }

  .text {
    margin-top: ${space(3)};
    padding: 0px;
    margin-bottom: ${({ isShop }) => (isShop ? `${space(4)}` : 0)};

    a {
      color: ${({ theme }) => theme.color};
    }
  }

  .ctaContainer {
    display: ${({ isShop }) => (isShop ? 'none' : 'initial')};
    margin-top: ${space(4)};
    margin-bottom: ${space(4)};

    a {
      background: ${colors.neutral[100]};
      border: 0;
      border-radius: 0;
      color: ${({ theme, gradient }) => (gradient ? getSectionGradient(theme) : theme.background)};
    }
  }

  ${media.min('medium')`
    padding: 64px ${space(15)} 64px ${space(15)}; // padding del texto: más altura arriba y abajo
    max-width: 50%;
    height: 100%;

    .title {
      ${fonts.titleMD};
      margin-top: ${space(2)};
    }

    .text {
      margin-left: 0;
      margin-top: ${space(2)};
    }

    .ctaContainer {
      display: initial;
      margin-top: ${space(3)};
      margin-bottom: 0;
    }
  `}

  ${media.min('fullwidth')`
    max-width 50%;

    .imgFullBackground & {
      max-width: 100%;
    }
    .contentZone & {
      max-width: 50%;
    }
  `}
`;

const ImageZone = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  height: 100%;

  .image {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  }

  ${media.min('medium')`
    max-width: 50%;
    height: 100%;

    .image {
      width: 100%;
      height: 100%;
      img, picture {
        max-width: initial;
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
  `}

  ${media.min('fullwidth')`
    .image {
      height: auto;
    }
  `}
`;

export { Module, ContentZone, Container, TextZone, ImageZone };
